// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6c813d21","68":"565cb24f","72":"2e04230e","120":"b400be1b","130":"4d3f2f3f","132":"c973ccf3","142":"b776c8ec","208":"c31c6c0a","432":"ea8430a6","679":"8f4618a0","880":"e860c7a4","920":"19e2d6a8"}[chunkId] + ".chunk.js";
};